/* eslint-disable */
import * as agenciesApi from './agencies';
import * as artifactsApi from './artifacts';
import * as attachmentsApi from './attachments';
import * as authApi from './auth';
import * as campaignsApi from './campaigns';
import * as contactApi from './contact';
import * as conversationsApi from './conversations';
import * as invitationsApi from './invitations';
import * as locationsApi from './locations';
import * as messagesApi from './messages';
import * as metadataApi from './metadata';
import * as numbersApi from './numbers';
import * as providersApi from './providers';
import * as recipientsApi from './recipients';
import * as sessionsApi from './sessions';
import * as settingsApi from './settings';
import * as tccApi from './tcc';
import * as templatesApi from './templates';
import * as tokensApi from './tokens';
import * as transcribeApi from './transcribe';
import * as translationApi from './translation';
import * as usersApi from './users';
import * as videoApi from './video';

export default {
  agenciesApi,
  artifactsApi,
  attachmentsApi,
  authApi,
  campaignsApi,
  contactApi,
  conversationsApi,
  invitationsApi,
  locationsApi,
  messagesApi,
  metadataApi,
  numbersApi,
  providersApi,
  recipientsApi,
  sessionsApi,
  settingsApi,
  tccApi,
  templatesApi,
  tokensApi,
  transcribeApi,
  translationApi,
  usersApi,
  videoApi
};